var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"sub_title"},[_vm._t("default",function(){return [_vm._v("技能河南·人人持证")]})],2)}
var staticRenderFns = []

export { render, staticRenderFns }